import React, { memo } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { string, number } from 'prop-types'

const Svg = styled.svg`
	&:hover {
		circle {
			fill: ${({ hoverBackgroundColor }) => (hoverBackgroundColor ? hoverBackgroundColor : 'transparent')};
		}
		path {
			fill: ${({ hoverColor }) => hoverColor};
			stroke: ${({ hoverColor }) => hoverColor};
		}
	}
`

export const LinkedIn = memo(({ height = 30, variant = 'primary', width = 30 }) => {
	const {
		colors,
		socialProfileSvgs: { inverse, neutral, primary },
	} = useTheme()
	let backgroundColor = 'transparent'
	let fillColor = colors.secondary
	let hoverBackgroundColor = 'transparent'
	let hoverColor = colors.tertiary

	switch (variant) {
		case 'neutral':
			backgroundColor = neutral.backgroundColor
			fillColor = neutral.fillColor
			hoverBackgroundColor = neutral.hoverBackgroundColor
			hoverColor = neutral.hoverFillColor
			break
		case 'inverse':
			fillColor = inverse.fillColor
			hoverColor = inverse.hoverFillColor
			break
		case 'primary':
		default:
			fillColor = primary.fillColor
			hoverColor = primary.hoverFillColor
			break
	}
	return (
		<Svg
			height={height}
			width={width}
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			viewBox="0 0 26.1 26.1"
			style={{ enableBackground: 'new 0 0 26.1 26.1' }}
			xmlSpace="preserve"
			hoverColor={hoverColor}
			hoverBackgroundColor={hoverBackgroundColor}
		>
			<circle id="top" cx={13.1} cy={13.1} r={13.1} fill={backgroundColor} />
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M13,26.1c-7.2,0-13-5.8-13-13s5.8-13,13-13s13,5.8,13,13C26,20.2,20.2,26,13,26.1z M13,1C6.4,1,1,6.4,1,13
				s5.4,12,12,12s12-5.4,12-12S19.6,1,13,1z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M9.3,17.9c-0.3,0-0.5-0.2-0.5-0.5v-7.1C8.8,10,9,9.8,9.3,9.8l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0v7.1
				C9.8,17.6,9.6,17.9,9.3,17.9L9.3,17.9z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M12.7,17.9c-0.3,0-0.5-0.2-0.5-0.5l0,0v-7.1c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5l0,0v7.1
				C13.2,17.6,13,17.9,12.7,17.9L12.7,17.9z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M17.3,17.9c-0.3,0-0.5-0.2-0.5-0.5l0,0v-4.7c0-1-0.8-1.8-1.8-1.8s-1.8,0.8-1.8,1.8c0,0.3-0.2,0.5-0.5,0.5l0,0
				c-0.3,0-0.5-0.2-0.5-0.5l0,0c0-1.6,1.3-2.8,2.8-2.8s2.8,1.3,2.8,2.8v4.7C17.8,17.6,17.6,17.9,17.3,17.9z"
			/>
			<path
				fill={fillColor}
				stroke={fillColor}
				strokeWidth={0.5}
				strokeMiterlimit={10}
				d="M9.3,8.5c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9l0,0C10.2,8.1,9.8,8.5,9.3,8.5z M9.3,7.5
				C9.3,7.5,9.2,7.6,9.3,7.5C9.2,7.7,9.4,7.7,9.3,7.5C9.4,7.6,9.3,7.5,9.3,7.5z"
			/>
		</Svg>
	)
})
LinkedIn.propTypes = {
	color: string,
	height: number,
	width: number,
}
